import {
    afterRenderEffect,
    ChangeDetectionStrategy,
    Component,
    ElementRef,
    input,
    output,
    viewChild,
} from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';

import { ButtonComponent } from 'app/shared/components/button/button.component';
import { PillComponent } from 'app/shared/components/pill/pill.component';
import { PopoverPlacement, togglePopover } from 'app/shared/components/popover/popover.component';

export type FeatureOnboardingPlacement = Extract<PopoverPlacement, 'bottom' | 'bottom-left' | 'bottom-right'>;

let nextCardId = 0;

/** Coach mark presenting a new feature, shown in the top layer under its `anchor`. */
@Component({
    selector: 'app-feature-onboarding-card',
    templateUrl: './feature-onboarding-card.component.html',
    styleUrls: [
        '../../../shared/components/popover/popover.component.scss',
        './feature-onboarding-card.component.scss',
    ],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [ButtonComponent, PillComponent, TranslatePipe],
})
export class FeatureOnboardingCardComponent {
    readonly image = input.required<string>();
    readonly titleKey = input.required<string>();
    readonly descriptionKey = input.required<string>();
    readonly placement = input<FeatureOnboardingPlacement>('bottom');
    readonly anchor = input<HTMLElement>();
    readonly open = input(false);

    readonly discover = output<void>();
    readonly acknowledge = output<void>();
    /** Pointer entering or leaving the card; touch is ignored because it cannot hover. */
    readonly hovered = output<boolean>();

    private readonly id = `feature-onboarding-${nextCardId++}`;
    /** The `New` tag and title, and the description: what the trigger is described by. */
    readonly headingId = `${this.id}-heading`;
    readonly descriptionId = `${this.id}-description`;
    private readonly content = viewChild.required<ElementRef<HTMLElement>>('content');

    constructor() {
        afterRenderEffect(() => {
            const anchor = this.anchor() ?? null;
            togglePopover(this.content().nativeElement, this.open() && !!anchor, anchor);
        });
    }

    protected onHover(event: PointerEvent, hovered: boolean): void {
        if (event.pointerType !== 'touch') this.hovered.emit(hovered);
    }
}
